import React, { useMemo } from 'react';

import ButtonLoading from '@/common/components/molecules/ButtonLoading/ButtonLoading';
import useInvoice from '@/common/hooks/invoice/useInvoice';
import { ReactComponent as DownloadIcon } from '@/materiaux/assets/icons/download.svg';

import {
  ButtonInvoiceDefaultProps,
  ButtonInvoicePropTypes,
} from './ButtonInvoice.proptypes';

const ButtonInvoice = ({ disabled, isLoading, id, number }) => {
  const {
    onDownloadInvoice,
    isDisabled: isDisabledDownloadInvoice,
  } = useInvoice({ disabled, isLoading });

  /**
   * Check if action is disabled
   * @type {boolean}
   */
  const isDisabled = useMemo(
    () => ({
      loading: isLoading || isDisabledDownloadInvoice.loading,
      disabled: isLoading || isDisabledDownloadInvoice.disabled || disabled,
    }),
    [disabled, isLoading, isDisabledDownloadInvoice],
  );

  return (
    <ButtonLoading
      className="button--document"
      context="order-invoice"
      disabled={isDisabled.disabled}
      isLoading={isDisabled.loading}
      onClick={() => onDownloadInvoice({ order: { number }, invoice: { id } })}
      variant="primary-light"
    >
      <DownloadIcon className="button__icon" />
    </ButtonLoading>
  );
};

ButtonInvoice.defaultProps = {
  ...ButtonInvoiceDefaultProps,
};

ButtonInvoice.propTypes = {
  ...ButtonInvoicePropTypes,
};

export default ButtonInvoice;
